import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import videoNotFoundImg from "../../assets/dataNotFound.jpg";
import searchNotFoundImg from "../../assets/searchDataNotFound.jpg";
import { fetchVideos } from "../../features/videos/videosSlice";
import SkeletonLoading from "./SkeletonLoading";
import VideoGridItem from "./VideoGridItem";

export default function VideGrid() {
  const dispatch = useDispatch();
  const { videos, isLoading, isError, error } = useSelector(
    (state) => state.videos
  );
  const { tags, search, page, limit, author } = useSelector(
    (state) => state.filter
  );

  useEffect(() => {
    dispatch(fetchVideos({ tags, search, page, limit, author }));
  }, [dispatch, tags, search, page, limit, author]);

  // decide what to render
  let content;

  if (isLoading) {
    content = new Array(limit)
      .fill()
      .map((_, i) => <SkeletonLoading key={i} />);
  }
  if (!isLoading && isError) {
    console.log(error);
    content = (
      <div className="col-span-12 max-h-[30rem] flex justify-center items-center overflow-hidden">
        <div>
          <img
            className="w-auto h-full"
            src={videoNotFoundImg}
            alt="Video not found"
          />
          <p className="text-center font-medium text-red-400 text-lg">{error}</p>
        </div>
      </div>
    );
  }

  if (!isError && !isLoading && videos?.length === 0) {
    content = (
      <div className="col-span-12 max-h-[30rem] flex justify-center items-center overflow-hidden">
        <img
          className="w-auto h-full"
          src={searchNotFoundImg}
          alt="Search video not found"
        />
      </div>
    );
  }

  if (!isError && !isLoading && videos?.length > 0) {
    content = videos.map((video) => (
      <VideoGridItem key={video.id} video={video} />
    ));
  }

  return (
    <section className="pt-12">
      <section className="pt-12">
        <div className="grid grid-cols-12 gap-4 max-w-7xl mx-auto px-5 lg:px-0 min-h-[300px]">
          {content}
        </div>
      </section>
    </section>
  );
}
